<template>
  <div
    v-if="lat && lng"
    class="destination-map"
  >
    <div
      class="map-container w-full cursor-zoom-in"
      @click="openModal"
    >
      <MapboxPreview
        class="size-full"
        :center="coordinates"
        :zoom="zoom"
        :markers="[coordinates]"
      />
    </div>
    <LazyMapModal
      v-if="modalVisible"
      :coordinates="coordinates"
      :visible="modalVisible"
      :zoom="zoom"
      @on-hide="hideModal"
    />
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    lat: {
      type: Number,
      default: null,
    },

    lng: {
      type: Number,
      default: null,
    },

    /**
     * @prop {
     *   destination: string
     *   postcode: string
     *   locality: string
     *   city: string
     *   country: string
     * } location
     */
    location: {
      type: Object,
      default: () => ({}),
    },

    allowFullscreen: {
      type: Boolean,
      default: true,
    },
  },

  data () {
    return {
      modalVisible: false,
      zoom: 12,
    }
  },

  computed: {
    coordinates () {
      return [this.lng, this.lat]
    },
  },

  methods: {
    openModal () {
      this.modalVisible = true
    },

    hideModal () {
      this.modalVisible = false
    },
  },
})
</script>

<style lang="scss">
.destination-map {
  .map-container {
    height: 350px;
  }

  &-hotel-here-text {
    span {
      font-size: 1.15rem;
      font-weight: normal;
      letter-spacing: 1px;

      @media (max-width: theme('screens.md')) {
        font-size: 1.1rem;
      }
    }

    svg {
      transform: scaleX(-1);
    }
  }
}
</style>
